<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/demande-changement-categorie-membre/"
    paramsName="changement_categorie_membre"
    :endpoint="endpoint"
    showPanier
    :getRefs="$refs"
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component 
        :is="path" 
        :sas="sas" 
        @validation-changed="setState(path, $event)" 
        :ref="path" 
        :endpoint="endpoint"
      >
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"

import Identification from "@/components/Formulaires/DemandeChangementCategorieMembre/Identification"
import LieuxExercice from "@/components/Formulaires/DemandeChangementCategorieMembre/LieuxExercice"
import SouscriptionAssurance from "@/components/form_parts/SouscriptionAssurance"
import Communications from "@/components/Formulaires/DemandeChangementCategorieMembre/Communications"
import Declarations from "@/components/Formulaires/DemandeChangementCategorieMembre/Declarations"
import DeclarationsJudiciaires from "@/components/form_parts/DeclarationsJudiciaires"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-changement-categorie-membre",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "lieux-exercice", code: "titre-etape-2", state: "" },
        { path: "souscription-assurance", code: "titre-etape-3", state: "" },
        { path: "communications", code: "titre-etape-4", state: "" },
        { path: "declarations-judiciaires", code: "titre-etape-5", state: "" },
        { path: "declarations", code: "titre-etape-6", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    Identification,
    LieuxExercice,
    SouscriptionAssurance,
    Communications,
    DeclarationsJudiciaires,
    Declarations
  }
}
</script>
